module.exports = "/_next/static/images/sz-59e2dbc4ca8688166475788e0848c18f.svg";